import { useEffect, useState } from 'react';
import { VoucherHolderAction } from '../voucher-holder-action';
import { Modal, Button, FormGroup, Row, Col } from 'react-bootstrap';
import FileUpload from '@nkr/components/file-upload';
import usePrevious from '@nkr/services/use-previous';

const uploadMap = [
    { type: VoucherHolderAction.UploadVoucherConsent, description: 'Voucher Consent' },
    { type: VoucherHolderAction.UploadSwabResults, description: 'Swab Results' },
    { type: VoucherHolderAction.UploadScreeningResults, description: 'Screening Results' },
];

interface IProps {
    show: boolean,
    donorAlias: string,
    voucherHolderFullName: string,
    type: VoucherHolderAction,
    isDonorProfile: boolean,
    onUpload: (file: File) => void,
    onCancel: () => void
}

const UploadModal = (props: IProps) => {
    const [uploads, setUploads] = useState([]);

    const previousShow = usePrevious(props.show);

    const handleUpload = () => {
        props.onUpload(uploads[0]);
    };

    const handleCancel = () => {
        props.onCancel();
    };

    const handleFileDropped = (acceptedFiles: File[]) => {
        setUploads(acceptedFiles);
    };

    const handleFileRemove = () => {
        setUploads([]);
    }

    useEffect(() => {
        if (!previousShow && props.show) {
            setUploads([]);
        }
    }, [props]);

    const disableUploadButton = uploads.length == 0;

    const uploadType = uploadMap.find(x => x.type == props.type);
    const uploadDescription = uploadType != null ? uploadType.description : '';

    return (
        <Modal backdrop='static' show={props.show} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Upload {uploadDescription}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {!props.isDonorProfile ?
                    <blockquote className='row' style={{ margin: '0px 0px 20px 0px' }}>
                        <div className='col-xs-12 col-lg-2'>Donor:</div>
                        <div className='col-xs-12 col-lg-9'>{props.donorAlias}</div>

                        <div className='col-xs-12 col-lg-2'>Voucher:</div>
                        <div className='col-xs-12 col-lg-9'>{props.voucherHolderFullName}</div>
                    </blockquote>
                    :
                    <blockquote>
                        {props.voucherHolderFullName}
                    </blockquote>
                }

                <FormGroup>
                    <FileUpload
                        label={`Click here to select the ${uploadDescription} consent document PDF file...`}
                        files={uploads}
                        accept='.pdf'
                        onFileDropped={handleFileDropped}
                        onRemoveFile={handleFileRemove}
                        singleUploadOnly={false}
                    />
                </FormGroup>

            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='primary' disabled={disableUploadButton} onClick={handleUpload}>Upload Document</Button>
                <Button onClick={handleCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default UploadModal;